import { twMerge } from 'tailwind-merge';

import React from 'react';

// TODO fix this
interface ControlledCheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const ControlledCheckBox: React.FC<ControlledCheckBoxProps> = ({ label, ...props }) => {
  return (
    <div className="flex gap-3">
      <input
        {...props}
        type="checkbox"
        className={twMerge(`bg-grey-100 cursor-pointer text-white accent-green-300`, props.className)}
        style={{
          backgroundColor: '#eee',
          boxShadow: 'inset 0px 2px 2px rgba(0, 0, 0, 0.1)',
          borderRadius: '4px',
          color: '#ffffff',
          height: '20px',
          width: '20px',
          border: 'none',
          ...props.style,
        }}
      />
      {label && <h1 className="text-body-1 font-medium">{label}</h1>}
    </div>
  );
};
